import { IRequirements } from "./Requirements";

export interface IDocumentTypeDocumentQuestionEnvelope {
  documentTypeDocumentQuestionsDTO: IDocumentQuestion[];
  documentTypeDocumentQuestionCount: number;
}

export interface IDocumentQuestion {
  documentTypeId: string;
  documentType: string;
  documentQuestionId: string;
  documentQuestion: string;
  requirements: string;
}

//interface extention for custom built items like time in a datetime
export interface IDocumentQuestionFormValues
  extends Partial<IDocumentQuestion> {
}

//empty form model
export class DocumentQuestionFormValues implements IDocumentQuestionFormValues {
  documentTypeId: string = "";
  documentType: string = "";
  documentQuestionId: string = "";
  documentQuestion: string = "";
  requirements: string = "";

  constructor(
    DocumentTypeId?: string,
    DocumentQuestionId?: string,
    requirements?: IRequirements
  ) {
    if (DocumentTypeId) {
      this.documentTypeId = DocumentTypeId;
    }
    if (DocumentQuestionId) {
      this.documentQuestionId = DocumentQuestionId;
    }
    if (requirements) {
      // this.requirements=requirements
    }
    Object.assign(this);

    Object.assign(this);
  }
}
